import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { addSubunits } from '../Charts/D3/helpers';
import './Concept.css';

const Concept = props => {
    const
        { onClick, selection, estratosDispatch, sectorDispatch, style, children } = props,
        { isLoading, geography, neighborhoodPolygon } = estratosDispatch,
        { sector } = sectorDispatch
    ;
    useEffect(() => {
        if( selection == 'neighborhood') {
            !isLoading && addSubunits({
                id : 'city-container',
                ...geography,
                sector: sector,
                neighborhood: neighborhoodPolygon
            })
        }
    },[selection])
    ;
    return (
        <div className='container concept-container' style={ style }>
            { children }
        </div>
    )
}

const mapStateToProps = () => (
    dispatch => ({
        estratosDispatch: dispatch.estratos,
        sectorDispatch: dispatch.sector
    })
)

export default connect(mapStateToProps)(Concept);
